
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AccessDecision } from '../class/AutoLockAccess';

@Injectable({
  providedIn: 'root',
})
export class AccessDecisionService {
  private accessDecisionSource = new BehaviorSubject<AccessDecision | null>(null);
  accessDecision$ = this.accessDecisionSource.asObservable();

  setAccessDecision(accessDecision: AccessDecision): void {
    this.accessDecisionSource.next(accessDecision);
  }

  getAccessDecision(): AccessDecision | null {
    return this.accessDecisionSource.value;
  }
}
